module.exports = __webpack_public_path__ + "img/pending.4690fbfa.svg";